import { daysUntil, getDeliveryDueDate, isCompleteStatus } from './healthStatus'

function pluralDays(value, label) {
  return `${value} ${value === 1 ? 'day' : 'days'} ${label}`
}

export function buildAlerts({ deliveries = [], deals = [] } = {}) {
  const overdueDeliveryAlerts = deliveries.flatMap(delivery => {
    const dueDate = getDeliveryDueDate(delivery)
    const days = daysUntil(dueDate)

    if (!dueDate || days === null || days >= 0 || isCompleteStatus(delivery.status)) return []

    const deal = delivery.rights?.deals
    const dealId = delivery.rights?.deal_id || deal?.id

    return [{
      id: `delivery-${delivery.id}`,
      type: 'delivery',
      severity: 'critical',
      title: delivery.name || delivery.rights?.name || 'Overdue delivery',
      subtitle: deal?.name || 'Unassigned deal',
      clientName: deal?.clients?.name || null,
      detail: pluralDays(Math.abs(days), 'overdue'),
      dueDate,
      days,
      dealId,
      path: dealId ? `/deals/${dealId}?tab=rights` : null
    }]
  })

  const expiringDealAlerts = deals.flatMap(deal => {
    const days = daysUntil(deal.end_date)

    if (deal.status !== 'active' || days === null || days < 0 || days > 30) return []

    return [{
      id: `deal-${deal.id}`,
      type: 'deal',
      severity: 'warning',
      title: deal.name || 'Expiring deal',
      subtitle: deal.clients?.name || deal.client_name || 'Client',
      clientName: deal.clients?.name || deal.client_name || null,
      detail: days === 0 ? 'Expires today' : pluralDays(days, 'until expiry'),
      dueDate: deal.end_date,
      days,
      dealId: deal.id,
      path: `/deals/${deal.id}`
    }]
  })

  return [...overdueDeliveryAlerts, ...expiringDealAlerts].sort((a, b) => {
    if (a.severity !== b.severity) return a.severity === 'critical' ? -1 : 1
    return a.days - b.days
  })
}
